<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('death.Date_of_death') }}</h5>
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('death.Date_of_death') }} *</label>
                  <input v-model="localFormData.departureDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('death.Date_of_death')">
                  <span v-if="v$.departureDate.$error" class="text-sm text-danger">
                      {{ v$.departureDate.$errors[0].$message }}
                  </span>
                  <span v-if="showPastDateWarning" class="text-sm text-danger d-block mt-2">
                    {{ $t('death.7_days_message') }}
                  </span>
              </div>
          </div>
      </div>         
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>
<script>
  import { computed, reactive, watch } from 'vue'
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "DateSection",
    props: {      
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {
      const { t } = useI18n()
      const localFormData = reactive({ ...props.formData })
      
      const todayDate = new Date().toISOString().split('T')[0];

      const rules = computed(() => {
          return {
              departureDate: { required: helpers.withMessage(t('common.Required'), required) }
          }
      })  

      const v$ = useVuelidate(rules, localFormData)

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })
      
      const showPastDateWarning = computed(() => {
        if (!localFormData.departureDate) return false;

        const selectedDate = new Date(localFormData.departureDate);
        const today = new Date();
        const diffInDays = (today - selectedDate) / (1000 * 60 * 60 * 24);
        
        return diffInDays > 7;
      });

      const validateAndPrevStep = async () => {
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          Object.assign(props.formData, localFormData)
          props.prevStep()
        }
      }

      const validateAndNextStep = async () => {          
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          props.nextStep()
        }
      }

      

      return {
        localFormData,
        v$,
        showPastDateWarning,
        validateAndPrevStep,
        validateAndNextStep,
        todayDate
      }
    }    
};
</script>